var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPoint2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.430176,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#323A73"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.84204 10.6423C5.84204 6.92845 8.83523 4 12.4303 4C16.0253 4 19.0185 6.92845 19.0185 10.6423C19.0185 14.1257 17.0097 18.2171 13.7692 19.7065C13.3458 19.9002 12.8904 20 12.4303 20C11.9702 20 11.5148 19.9002 11.0914 19.7065C7.85082 18.2171 5.84204 14.1266 5.84204 10.6423ZM12.4303 5.37143C9.45239 5.37143 7.11718 7.77599 7.11718 10.6423C7.11718 13.685 8.90663 17.2114 11.5929 18.4457C11.8578 18.5663 12.1426 18.6285 12.4303 18.6285C12.718 18.6285 13.0027 18.5663 13.2676 18.4457C15.9539 17.2114 17.7434 13.685 17.7434 10.6423C17.7434 7.77691 15.4082 5.37143 12.4303 5.37143Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4305 11.9999C13.2102 11.9999 13.8422 11.3679 13.8422 10.5882C13.8422 9.80848 13.2102 9.17641 12.4305 9.17641C11.6508 9.17641 11.0187 9.80848 11.0187 10.5882C11.0187 11.3679 11.6508 11.9999 12.4305 11.9999ZM12.4305 13.4117C13.9899 13.4117 15.254 12.1476 15.254 10.5882C15.254 9.02879 13.9899 7.76465 12.4305 7.76465C10.8711 7.76465 9.60693 9.02879 9.60693 10.5882C9.60693 12.1476 10.8711 13.4117 12.4305 13.4117Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint2);
export default __webpack_public_path__ + "static/media/Point2.f270b0f4ab7b4ff43be416672e69052e.svg";
export { ForwardRef as ReactComponent };